const FULLSTORY_FLAG = 'f_ar_fullstory';
const CONVIVA_WEB_SDK_FLAG = 'f_ar_conviva_web_tracker';
const MULTI_BRAND_FLAG = 'f_ar_multi_brand';
const USERPROFILE_API_FLAG = 'f_bootstrap_user_profile_api_version';
const BRAZE_FLAG = 'f_ar_braze_sdk';

export {
    FULLSTORY_FLAG,
    CONVIVA_WEB_SDK_FLAG,
    MULTI_BRAND_FLAG,
    USERPROFILE_API_FLAG,
    BRAZE_FLAG,
};
